import { Component, OnInit } from "@angular/core";
import { PhoneCompatabilityService } from "./phone-compatability.service";
import { Router, ActivatedRoute } from "@angular/router";
import { TCCPLocalStorageService } from "../../services/tccp-local-storage.service";
import { TCCPCommonService } from "../../services/tccp-common.service";
import { environment } from "../../../../environments/environment";
import { PhoneManufacturerService } from "../../components/phone-manufacturer/phone-manufacturer.service";
import { LoaderService } from "../../loader/loader.service";
import { MatTooltip } from "@angular/material/tooltip";

@Component({
  selector: "app-phone-compatability",
  templateUrl: "./phone-compatability.component.html",
  styleUrls: ["./phone-compatability.component.scss"],
})
export class PhoneCompatabilityComponent implements OnInit {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private phoneCompatabilityService: PhoneCompatabilityService,
    public commonService: TCCPCommonService,
    public storageService: TCCPLocalStorageService,
    private phoneManufacturerService: PhoneManufacturerService,
    public loaderService: LoaderService
  ) {
    this.windowWidth = window.innerWidth;
    this.isPhoneCompatabilityFromDirectLink =
      this.storageService.getPhoneCompatabilityDirectLink();
  }

  public phoneCompatabilityList = [];
  public phoneHUConfigInfoList = [];
  public windowWidth: number;
  public phoneModel = "";
  public phoneModelYear = "";
  public selectedPhoneModel = "";
  public appName = environment.applicationName;
  public phoneFeatureList: { [key: string]: any } = [];
  public huPhoneCongfigList = [];
  public dataLoaded: Promise<boolean>;
  public compatibleLegend = [];
  public showDisclaimer = false;
  public tileElevationIndex: number[] = [-1, -1];
  public tileElevationStyles: any;
  public isPhoneCompatabilityFromDirectLink = false;
  public softwareVersionList: any;
  public isToyota: boolean;

  ngOnInit() {
    this.isToyota = this.appName === "toyota";
    this.compatibleLegend = [
      { name: "Compatible", value: "fa fa-check-circle color-green" },
      {
        name: "Partially Compatible",
        value: "fa fa-minus-circle color-yellow",
        color: "color-yellow",
      },
      { name: "Not Compatible", value: "fa fa-times-circle color-red" },
      { name: "Not Applicable", value: "fa fa-ban color-gray" },
      { name: "Not Tested", value: "fa fa-question-circle color-blue" },
    ];
    this.windowWidth = window.innerWidth;
    if (this.storageService.getHuPhoneConfigInfoList() && this.storageService.getHuPhoneConfigInfoList() !== undefined) {
      this.phoneHUConfigInfoList = this.storageService.getHuPhoneConfigInfoList();

    }
     else if (this.storageService.getHeadUnitConfigList()){
      this.phoneHUConfigInfoList = this.storageService.getHeadUnitConfigList();
      this.getPhoneCompatabilityList();
    }
    if (this.storageService.getBtPhoneModel()) {
      this.selectedPhoneModel = this.storageService.getHuPhoneConfigInfoList();
      this.getPhoneCompatabilityList();
    } else if (this.phoneHUConfigInfoList) {
      this.selectedPhoneModel = this.storageService.getPhoneModel();
      this.getPhoneCompatabilityList();
    } 
   else {
      this.router.navigateByUrl(`${this.appName}/bluetooth-compatability`);
    }
  }

  backToManufacturerPage() {
    this.storageService.setBackToPhoneSelection(true);
    if (this.isPhoneCompatabilityFromDirectLink) {
      this.storageService.setVehicleYear(Number(null), null);
      this.storageService.setVehicleModel(null, null);
      this.router.navigateByUrl(`${this.appName}/phone-compatability`);
    } else {
      this.router.navigateByUrl(`${this.appName}/bluetooth-compatability`);
    }
  }

  public getPhoneCompatabilityList() {
    this.loaderService.show();
    const headUnitsKey = "headUnits";
    const phoneConfigIdKey = "phoneConfigId";
    const btPhoneConfigIdKey = "PhoneConfigId";
    const huConfigIdKey = "huConfigId";
    const featureInfoKey = "featureInfo";
    const featureGroupNameKey = "groupName";
    const featureInfoListKey = "featureInfoList";
    const featureInfoListLengthKey = "featureInfoListLength";
    const featurePhoneCompIdKey = "featurePhoneCompId";
    const featureGroupPhoneCompIdKey = "groupPhoneCompId";
    const featureGroupHuCompLongDescKey = "featureGroupHuCompLongDesc";
    const softwareTextKey = "softwareVersionText";

    if (this.phoneHUConfigInfoList) {
      this.phoneHUConfigInfoList[headUnitsKey].forEach((data, huIndex) => {
        this.phoneCompatabilityService
          .getPhoneCompatabilityListByHUPhoneConfigId(
            this.phoneHUConfigInfoList[headUnitsKey][huIndex][huConfigIdKey],
            this.phoneHUConfigInfoList[headUnitsKey][huIndex][phoneConfigIdKey]
              ? this.phoneHUConfigInfoList[headUnitsKey][huIndex][
                  phoneConfigIdKey
                ]
              : this.phoneHUConfigInfoList[headUnitsKey][huIndex][
                  btPhoneConfigIdKey
                ]
              ? this.phoneHUConfigInfoList[headUnitsKey][huIndex][
                  btPhoneConfigIdKey
                ]
              : this.storageService.getBtPhoneModel()
          )
          .then((pData) => {
            if (pData) {
              this.phoneHUConfigInfoList[headUnitsKey][huIndex][
                featureInfoKey
              ] = pData;
              this.phoneFeatureList =
                this.phoneCompatabilityList[0][featureInfoKey];
              this.softwareVersionList =
                this.phoneHUConfigInfoList[headUnitsKey][huIndex][
                  featureInfoKey
                ].data.softwareVersions;
              let softwareVersionText = "";
              this.softwareVersionList.forEach((soVersion) => {
                softwareVersionText +=
                  soVersion.appName + " - " + soVersion.appVersion + "\n";
              });
              const featureList = [];
              this.phoneCompatabilityList[huIndex][
                featureInfoKey
              ].data.featureGroups.forEach((fData, fIndex) => {
                featureList.push(fData[featureGroupNameKey]);
              });
              this.phoneHUConfigInfoList[headUnitsKey][huIndex][
                featureInfoListKey
              ] = featureList;
              this.phoneHUConfigInfoList[headUnitsKey][huIndex][
                softwareTextKey
              ] = softwareVersionText;
              this.phoneHUConfigInfoList[headUnitsKey][huIndex][
                featureInfoListLengthKey
              ] = featureList.length;
              if (
                huIndex ===
                this.phoneHUConfigInfoList[headUnitsKey].length - 1
              ) {
                this.dataLoaded = Promise.resolve(true);
                this.loaderService.hide();
                if (this.dataLoaded) {
                  const maxFeatureList = Math.max.apply(
                    Math,
                    this.phoneHUConfigInfoList[headUnitsKey].map(
                      (o, index) => o.featureInfoListLength
                    )
                  );
                  const maxFeatureListInfo = this.phoneHUConfigInfoList[
                    headUnitsKey
                  ].find((e) => e.featureInfoListLength === maxFeatureList);
                  const maxFeatureListIndex = this.phoneHUConfigInfoList[
                    headUnitsKey
                  ].findIndex(
                    (e) => e.featureInfoListLength === maxFeatureList
                  );
                  this.phoneHUConfigInfoList[headUnitsKey].forEach(
                    (hucdata, hucIndex) => {
                      if (hucIndex !== maxFeatureListIndex) {
                        maxFeatureListInfo[featureInfoListKey].forEach(
                          (item, mIndex) => {
                            if (hucdata[featureInfoListKey].indexOf(item) < 0) {
                              const featureGroupInfo = JSON.parse(
                                JSON.stringify(
                                  this.phoneHUConfigInfoList[headUnitsKey][
                                    maxFeatureListIndex
                                  ][featureInfoKey].data.featureGroups[mIndex]
                                )
                              );
                              hucdata[featureInfoKey].data.featureGroups.splice(
                                mIndex,
                                0,
                                Object.assign({}, featureGroupInfo)
                              );
                              const featureInfo = [
                                ...featureGroupInfo.features,
                              ];
                              featureInfo.forEach((feData, feIndex) => {
                                feData[featurePhoneCompIdKey] = "7";
                                hucdata[featureInfoKey].data.featureGroups[
                                  mIndex
                                ].features.push(feData);
                              });
                              hucdata[featureInfoKey].data.featureGroups[
                                mIndex
                              ][featureGroupPhoneCompIdKey] = "7";
                              hucdata[featureInfoKey].data.featureGroups[
                                mIndex
                              ][featureGroupHuCompLongDescKey] =
                                "Not Applicable";

                              this.phoneHUConfigInfoList[headUnitsKey][
                                hucIndex
                              ] = hucdata;
                            }
                          }
                        );
                      }
                    }
                  );
                }
              }
            }
          });
      });

      this.phoneCompatabilityList = this.phoneHUConfigInfoList[headUnitsKey];
    }
    this.loaderService.hide();
  }

  hideTooltipIn(
    tooltip: MatTooltip,
    ms: number,
    mouseLoc: boolean,
    categoryMappingIndex: number
  ) {
    this.tileElevationStyles = mouseLoc ? "published-scale" : "";
    tooltip.toggle();
    setTimeout(() => tooltip.hide(), ms);
  }

  setFeatureInfo(HUIndex, featureGroupIndex, featureIndex) {
    const fetchIndex = HUIndex && HUIndex === 0 ? 1 : 0;
    const featureInfo =
      this.phoneHUConfigInfoList["headUnits"][fetchIndex].headUnit.featureInfo
        .data.featureGroups[featureGroupIndex]["featureList"]["feature"][
        featureIndex
      ];
    featureInfo["featurePhoneCompId"] = "7";
    this.phoneHUConfigInfoList["headUnits"][HUIndex].headUnit.featureInfo[
      featureGroupIndex
    ]["featureList"]["feature"].splice(
      featureIndex,
      0,
      Object.assign({}, featureInfo)
    );
  }
}
